import { getNaturalsAdminApiBase } from "../../admin-shared/naturalsSalonAdminApiBase";
import { PORTAL_HEADER, clearPortalStorage as clearNamedPortalStorage } from "../../admin-shared/storage";

export const PORTAL_ID = "partner";

export function getApiBase() {
  return getNaturalsAdminApiBase();
}

/** @deprecated use getApiBase() — resolved per request */
export const API_BASE = getNaturalsAdminApiBase();

export function clearPortalStorage() {
  clearNamedPortalStorage(PORTAL_ID);
}

export function hasHqSession() {
  return Boolean(localStorage.getItem("naturals_partner_userId"));
}

export function hqFetch(input, init = {}) {
  const headers = new Headers(init.headers || {});
  headers.set(PORTAL_HEADER, PORTAL_ID);
  return fetch(input, {
    ...init,
    headers,
    credentials: init.credentials ?? "include",
  });
}

export const api = (endpoint, options = {}) => {
  const normalizedEndpoint = endpoint?.startsWith("/") ? endpoint : `/${endpoint || ""}`;
  const { headers: extraHeaders, ...rest } = options;
  return fetch(`${getApiBase()}${normalizedEndpoint}`, {
    method: options.method || "GET",
    headers: {
      "Content-Type": "application/json",
      [PORTAL_HEADER]: PORTAL_ID,
      ...(extraHeaders || {}),
    },
    credentials: "include",
    ...rest,
  });
};
